import { SubscriptionName } from '@anm/api/modules/subscription';
import getMembersCountFromTeamName from '@anm/helpers/subscription/getMembersCountFromTeamName';
import isTeamSubscription from '@anm/helpers/subscription/isTeamSubscription';
import useSwitchState from '@anm/hooks/useSwitchState';
import { memo, useCallback, useEffect, useRef, FC } from 'react';
import { useSelector } from 'react-redux';

import routes from '../../../routes';
import { userSelectors } from '../../../store/modules/user';
import useSubscriptionChangeState from '../PricingSubscriptionContent/hooks/useSubscriptionChangeState';

import SuccessAlert from './SuccessAlert';

const { Router } = routes;
type SuccessUpgradeAlertProps = { subscriptionName?: SubscriptionName };

export const SuccessUpgradeAlert: FC<SuccessUpgradeAlertProps> = ({ subscriptionName }) => {
  const messageRef = useRef<string>();
  const currentSubscription = useSelector(userSelectors.selectWaveSubscription);
  const subscriptionChange = useSubscriptionChangeState();
  const [isAlertShown, showAlert, closeAlert] = useSwitchState();
  const handleCloseAlert = useCallback(() => {
    closeAlert();
    Router.pushRoute('my-projects');
  }, []);

  const getUpgradeMessage = () => {
    if (!subscriptionChange) return;

    const isTeam = isTeamSubscription(subscriptionChange.planName);
    const membersCount = getMembersCountFromTeamName(subscriptionChange.planName);
    const { displayName } = subscriptionChange;
    const name = isTeam && membersCount ? `${displayName} ${membersCount}` : displayName;
    const upgradeMessage = `Your account was upgraded to ${name}`;

    return upgradeMessage;
  };
  const getAlertMessage = () => {
    const isPeriodChangeView = subscriptionName === currentSubscription?.name;
    const changePeriodMessage = 'Your billing period has changed!';

    return isPeriodChangeView ? changePeriodMessage : getUpgradeMessage();
  };

  useEffect(() => {
    messageRef.current = getAlertMessage();
    subscriptionChange && !isAlertShown ? showAlert() : closeAlert();
  }, [!!subscriptionChange]);

  return (
    <>
      {isAlertShown && messageRef.current && (
        <SuccessAlert alertMessage={messageRef.current} onClose={handleCloseAlert} />
      )}
    </>
  );
};

export default memo(SuccessUpgradeAlert);
